import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Constants } from '../../shared/Constants';

@Injectable()
export class ClientService {

    constructor(private http: HttpClient) { }



    getClientByName(name) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.get(Constants.URL_BACKEND + '/clienteFilter?name=' + name, { headers: headers });
      }

    getClientListBilling() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.get(Constants.URL_BACKEND + '/HS_GetClientsBilling/', { headers: headers });
    }


    getClientList() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.get(Constants.URL_BACKEND + '/clients', { headers: headers });
    }

    getClientContacts(id_client){
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.get(Constants.URL_BACKEND + '/clientContact/' + id_client, { headers: headers });
    }

    createClient(clientData) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.post(Constants.URL_BACKEND + '/clients', { data: clientData }, { headers: headers });
    }

    updateClient(idClient, updateClient) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.put(Constants.URL_BACKEND + '/clients/' + idClient, { data: updateClient }, { headers: headers });
    }

    deleteClient(idUser) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.delete(Constants.URL_BACKEND + '/clients/' + idUser, { headers: headers });
    }

    getClientProducts(id_client){
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.get(Constants.URL_BACKEND + '/client-product/' + id_client, { headers: headers });
    }

    getClientMarcas(id_client){
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.get(Constants.URL_BACKEND + '/client-marca/' + id_client, { headers: headers });
    }

}




// WEBPACK FOOTER //
// ./src/app/system/services/client.service.ts